import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';

import { FertilizerModelService } from './service';
import { UpdateService } from '../../../../services/update.service';
import { FertilizerBaseDialog } from './fertilizer.dialog.base';
import { IRanchFertilizerFormResult } from './interfaces';
import { RanchFertilizerFormComponent } from '../../shared/ranch-fertilizer-form/main';
import { IIdNamePair } from '../../../../interfaces/abstract';

@Component({
	moduleId: module.id,
	selector: 'fertilizer-create-dialog',
	templateUrl: 'fertilizer.create.dialog.html',
	styleUrls: ['fertilizer.create.dialog.scss']
})

export class FertilizerCreateDialog extends FertilizerBaseDialog implements OnInit {

	public isSaving: boolean;
	@ViewChild(RanchFertilizerFormComponent, { static: false })
	public fertilizerForm: RanchFertilizerFormComponent;

	constructor(
		protected _dialog: MatDialog,
		public _dialogRef: MatDialogRef<FertilizerCreateDialog>,
		private service: FertilizerModelService,
		private updateService: UpdateService,
	) {
		super(_dialog, null);
	}

	ngOnInit(): void {
		this.isSaving = false;
	}

	public close(): void {

		if (!this.fertilizerForm || !this.fertilizerForm.isTouched) {
			this._dialogRef.close();
		} else {
			this._openKeepDiscardDialog();
		}
	}

	public submit(result: IRanchFertilizerFormResult): void {
		let promise: Promise<IIdNamePair | void>;

		if (this.isSaving) {
			return;
		}

		this.isSaving = true;

		if (result.IsCustomFertilizer) {
			promise = this.service.add(result.CustomFertilizer);
		} else {
			promise = this.service.addBatch(result.SelectedFertilizerIds);
		}

		promise.then(() => {
			this.isSaving = false;
			this.updateService.setRanchSettingsUpdated('fertilizers');
			this._dialogRef.close();
		});
	}
}
